<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Enter process name</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="newProcessState" @submit.prevent="saveNewProcess">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <validate :custom="{isUnique: isUnique}">
                  <v-text-field
                    v-model="name"
                    required
                    label="Name"
                    name="name"
                    maxlength="40"
                    hide-details
                    counter
                    clearable
                  >
                  </v-text-field>
                  <field-messages
                    name="name"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Name is a required field
                    </small>
                    <small class="error--text" slot="isUnique">
                      Name must be unique
                    </small>
                  </field-messages>
                </validate>
              </v-flex>

              <v-flex xs4>
                <v-checkbox
                  v-model="isLoadFromSet"
                  label="Load from Set?"
                ></v-checkbox>

              </v-flex>

              <v-flex xs6 v-if="isLoadFromSet">
                <async-autocomplete
                  v-model.number="selectedSetId"
                  :items="models.ComponentSets.query().where('object_type', 'PROCESS').get()"
                  name="set"
                  label=""
                  item-text="name"
                  item-value="id"
                />
              </v-flex>

            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Process
  from '@/orm/models/Process';
import * as models from '../../../orm/models/';
import asyncAutocomplete from '@/components/form/asyncAutocomplete';

export default {
  name: 'newProcessPopup',
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      models,
      name: '',
      newProcessState: {},
      isLoadFromSet: false,
      selectedSetId: 0,
    };
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
  },
  methods: {
    isUnique(name) {
      return !Process.all().some(p => p.name === name);
    },
    close() {
      this.name = '';
      this.newProcessState._reset();
      this.dialogLocal = false;
    },
    saveNewProcess() {
      if (!this.newProcessState.$valid) {
        return;
      }
      let processData = null;
      if (this.selectedSetId > 0) {
        let selectedSet = models.ComponentSets.find(this.selectedSetId);
        let content = JSON.parse(JSON.stringify(selectedSet.content));

        processData = content.process;
        processData.name = this.name;
        delete processData.id;
      }
      this.$emit('createNewProcess', this.name, processData);
      this.close();
    },
  },
  components: {
    asyncAutocomplete,
  },
};
</script>
